import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/compass.vue
var o = {
	name: "DtIconCompass",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--compass"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Compass",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M10.5 6a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0ZM7.962 3.405a.5.5 0 0 1 .633.633l-.903 2.705a1.502 1.502 0 0 1-.949.95l-2.705.9a.5.5 0 0 1-.633-.631l.903-2.706a1.5 1.5 0 0 1 .949-.948l2.705-.903Zm-2.39 1.85a.501.501 0 0 0-.315.317h-.001L4.67 7.328l1.758-.585a.5.5 0 0 0 .316-.315v-.001L7.33 4.67l-1.757.586ZM11.5 6a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=compass.js.map